import { Locale } from '@frontend/common';
import { Logger } from '@frontend/logger';

import useLocale from '../useLocale';

export const getCorrectTranslation = <T extends object>(locale: Locale | undefined, object: T, translateKey: keyof T) => {
    const userLocale = locale?.toLowerCase().replace(/-/g, '_');
    const found = Object.entries(object).find(([key]) => key.includes((translateKey as string) + '_' + userLocale));
    if (found) {
        if (found[1] == null || found[1] === '') {
            return ' '; // return a space because badges will think theyre still loading if the string === ''
        }
        return found[1];
    } else return object[translateKey];
};

export interface TranslatedStringProps<T extends object> {
    locale?: Locale;
    object: T;
    objectKey: string;
}

export const TranslatedString = <T extends object>(props: TranslatedStringProps<T>) => {
    const { locale } = useLocale();
    const relevantLocale = props.locale ?? locale;
    if (!relevantLocale) return (props.object as { [objectKey: string]: string })[props.objectKey];
    const filteredKeys = Object.keys(props.object).filter((key) => key.includes(props.objectKey));
    const foundKey = filteredKeys.find((key) => key.includes(relevantLocale.toLowerCase().replace(/-/g, '_')));

    if (!foundKey) {
        Logger.error(`No translation found for key ${props.objectKey}`);
        return (props.object as { [objectKey: string]: string })[props.objectKey];
    }
    return (props.object as { [foundKey: string]: string })[foundKey];
};
